import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function KeyPlayers() {
  const {
    t
  } = useLanguage();
  const players = [{
    name: 'Vinícius Jr.',
    position: t('players.forward'),
    club: 'Real Madrid',
    number: '7',
    image: 'https://cdn.magicpatterns.com/uploads/dydtWvDdBeLaUiRCxPGbF4/image.png'
  }, {
    name: 'Neymar Jr.',
    position: t('players.forward'),
    club: 'Santos FC',
    number: '10',
    image: 'https://cdn.magicpatterns.com/uploads/j3oDXAQ9BroaABpAEWkZ5D/image.png'
  }, {
    name: 'Endrick',
    position: t('players.forward'),
    club: 'Real Madrid',
    number: '9',
    image: 'https://cdn.magicpatterns.com/uploads/sFtRsaUUvp5DCK34aoCtJ9/image.png'
  }, {
    name: 'Bruno Guimarães',
    position: t('players.midfielder'),
    club: 'Newcastle United',
    number: '5',
    image: 'https://cdn.magicpatterns.com/uploads/8RPTyah5cPMV5p8K2NYADC/image.png'
  }, {
    name: 'Marquinhos',
    position: t('players.defender'),
    club: 'PSG',
    number: '4',
    image: 'https://cdn.magicpatterns.com/uploads/xAjYcf4vkYCrUNd8Vp7Vzv/image.png'
  }, {
    name: 'Alisson Becker',
    position: t('players.goalkeeper'),
    club: 'Liverpool',
    number: '1',
    image: 'https://cdn.magicpatterns.com/uploads/2rVnVYPu9bCMbL8jVzLXGB/image.png'
  }];
  return <section className="py-10 md:py-24 bg-[#0a0a0a] relative overflow-hidden" data-id="element-193">
      <div className="container mx-auto px-4 md:px-12 mb-6 md:mb-12" data-id="element-194">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col md:flex-row md:items-end justify-between gap-4" data-id="element-195">
          <div data-id="element-196">
            <h2 className="text-brazil-green font-oswald uppercase tracking-widest text-xs md:text-sm font-bold mb-2" data-id="element-197">
              {t('players.label')}
            </h2>
            <h3 className="text-2xl md:text-5xl font-oswald font-bold uppercase" data-id="element-198">
              {t('players.title1')}{' '}
              <span className="text-brazil-yellow" data-id="element-199">{t('players.title2')}</span>
            </h3>
          </div>
          <a href="https://www.espn.com/soccer/team/squad/_/id/205/brazil" target="_blank" rel="noopener noreferrer" className="text-xs md:text-sm font-oswald uppercase tracking-widest text-gray-400 hover:text-white transition-colors flex items-center gap-2 min-h-[44px]" data-id="element-200">
            {t('players.viewSquad')}{' '}
            <span className="text-brazil-yellow" data-id="element-201">→</span>
          </a>
        </motion.div>
      </div>

      {/* Mobile: 2-column grid / Desktop: 6-column grid */}
      <div className="container mx-auto px-4 md:px-12" data-id="element-202">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-6" data-id="element-203">
          {players.map((player, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="group relative rounded-xl md:rounded-2xl overflow-hidden bg-[#111] border border-white/5 hover:border-brazil-green transition-all duration-500" data-id="element-204">
              <div className="aspect-[3/4] relative overflow-hidden" data-id="element-205">
                {/* Player Photo or Gradient Background */}
                {player.image ? <img src={player.image} alt={player.name} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" data-id="element-206" /> : <>
                    <div className="absolute inset-0 bg-gradient-to-br from-brazil-dark-green via-brazil-blue to-[#111] opacity-80 group-hover:opacity-100 transition-opacity duration-500" data-id="element-207"></div>
                    <div className="absolute inset-0 flex items-center justify-center z-10" data-id="element-208">
                      <span className="font-oswald text-8xl md:text-9xl font-bold text-white/10 group-hover:text-brazil-yellow/20 transition-colors duration-500 transform group-hover:scale-110" data-id="element-209">
                        {player.number}
                      </span>
                    </div>
                  </>}

                {/* Content */}
                <div className="absolute bottom-0 left-0 w-full p-4 md:p-5 z-20 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/80 to-transparent" data-id="element-210">
                  <p className="text-brazil-yellow font-oswald uppercase tracking-widest text-[8px] md:text-[10px] mb-0.5" data-id="element-211">
                    {player.position}
                  </p>
                  <h4 className="font-oswald text-sm md:text-xl font-bold uppercase mb-0.5 leading-tight text-white drop-shadow-md" data-id="element-212">
                    {player.name}
                  </h4>
                  <p className="text-[10px] md:text-xs text-gray-300 font-light drop-shadow-md" data-id="element-213">
                    {player.club}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}